export default {
  "fontElementMap": "ohQfq",
  "quoteContainer": "g5urf",
  "quote": "MDhob"
};